import { gql } from '@apollo/client';


export const GET_ALL_AFFILIATES = gql`
query getAllAffiliates ($pageSize: Int, $pageNumber: Int, $order_by: [affiliates_order_by!] = {}, $search_event: String = "%") {
  affiliates(limit: $pageSize, offset: $pageNumber, order_by: $order_by, where: {a_deleted_at:{_is_null:true},user:{_or:[{u_full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}}) {
    firstName: a_first_name
    lastName: a_last_name
    emailId: a_email_id
    user {
      id: a_id
      affiliateId: u_referral_code
      userFullName: u_full_name
      totalEarnings: u_total_earnings
      affiliater_ticket_details
      noOfUsers: user_referred_by_aggregate(where: {user_referred_to:{u_deleted_at:{_is_null:true}}}) {
        aggregate {
          count
        }
      }
    }
  }
  totalAffiliates: affiliates_aggregate(where: {a_deleted_at:{_is_null:true},user:{_or:[{u_full_name:{_ilike:$search_event}},{u_email_id:{_ilike:$search_event}}]}}) {
    aggregate {
      count
    }
  }
}
`;

export const GET_AFFILIATES = gql`
query GetAffiliates($limit: Int, $offset: Int, $searchText: String = "%", $referrerId: uuid = null, $aStatus: [String!] = ["Active", "Deactive"], $aType: [String!] = ["Direct", "Indirect", "Both"], $order_by: [affiliate_details_order_by!] = {}) {
  getAffiliates(limit: $limit, offset: $offset, args: {searchText: $searchText,referrerId:$referrerId}, where: {aStatus: {_in: $aStatus}, aType: {_in: $aType}}, order_by: $order_by) {
    aId
    aType
    totalAmount
    directPayout
    emailId
    firstName
    indirectPayout
    lastName
    noOfAffiliates
    noOfUsers
    referralCode
    uId
    userFullName
    aStatus
    aCreatedAt
    aUpdatedAt
    aOrganization
  }
}
`;

export const GET_AFFILIATE_COUNT = gql`
query GetAffiliateCount($searchText: String! = "%", $aStatus: String = null, $referrerId: uuid = null, $aType: String = null) {
  GetAffiliatesCount(args: {searchText:$searchText,,referrerId:$referrerId, aStatus:$aStatus, aType: $aType}) {
    totalCount
  }
}
`;

export const GET_AFFILIATE_COUNT_BY_MARKETING_USER = gql `
query GetAffiliateCountByCreatedById($searchText: String! = "%", $referrerId: uuid = null, $aStatus: String = null, $aType: String = null) {
  GetAffiliatesCount: GetAffiliateCountByCreatedById(args: {searchText:$searchText,,referrerId:$referrerId, aStatus:$aStatus, aType: $aType}) {
    totalCount
    createdBy
  }
}
`

export const CREATE_AFFILIATE = gql`
mutation AddAffiliate($firstname: String!, $lastname: String!, $emailid: String!, $referralcode: String!, $referrallink: String!) {
  addAffiliate(firstname: $firstname, lastname: $lastname, emailid: $emailid, referralcode: $referralcode, referrallink: $referrallink) {
    message
  }
}
`;

export const ADD_AFFILIATE = gql`
mutation AddAffiliate ($firstname: String!, $lastname: String!, $emailid: String!, $referralcode: String, $referrallink: String, $aType: String!, $isVanderbiltNILFund: Boolean!, $referredBy: uuid = null, $organization: String!) {
  addAffiliate(firstname: $firstname, lastname: $lastname, emailid: $emailid, referralcode: $referralcode, referrallink: $referrallink, aType: $aType, isVanderbiltNILFund: $isVanderbiltNILFund, referredBy: $referredBy, organization: $organization) {
    message
  }
}
`;

export const DELETE_AFFILIATE = gql`
mutation deleteAffiliateById ($affiliateId: uuid) {
  delete_affiliate_by_id(args: {affiliate_id:$affiliateId}) {
    a_id
    a_deleted_at
    a_email_id
  }
}
`;

export const GET_AFFILIATE_BY_ID = gql`
query getAffiliateById ($affiliateId: uuid!) {
  affiliates_by_pk(a_id: $affiliateId) {
    a_id
    a_first_name
    a_last_name
    a_email_id
    user {
      u_referral_link
    }
  }
}
`;

export const GET_AFFILIATE_BY_ID_DIRECT_INDIRECT = gql`
query getAffiliateById($aId: uuid!) {
  GetAffiliateById(args: {aId: $aId}) {
    aId
    aType
    aStatus
    emailId
    firstName
    lastName
    referredBy
    referralUrl
    referralCode
    referredById
    isSupportVanderbiltNILFund
    aOrganization
  }
}
`;

export const UPDATE_AFFILIATE = gql`
mutation updateAffiliateById ($affiliateId: uuid!, $firstName: String!, $lastName: String!) {
  affiliate: update_affiliates_by_pk(pk_columns: {a_id:$affiliateId}, _set: {a_first_name:$firstName,a_last_name:$lastName}) {
    a_id
    a_first_name
    a_last_name
    a_email_id
  }
  user: update_user(where: {a_id:{_eq:$affiliateId}}, _set: {u_first_name:$firstName,u_last_name:$lastName}) {
    returning {
      u_id
      u_first_name
      u_last_name
      u_email_id
      a_id
    }
  }
}
`;

export const EDIT_AFFILIATE =gql`
mutation EditAffiliate ($input: editAffiliateInput!) {
  editAffiliate(input: $input) {
    message
  }
}
`;

export const AFFILIATE_TYPE = gql`
query AffiliateType {
  affiliate_type {
    type
  }
}
`;

export const AFFILIATE_BY_TYPE = gql`
query AffiliateType($aType: [String!]) {
  affiliate_type(where: {type: {_in: $aType}}) {
    type
  }
}
`;

export const AFFILIATE_PAYOUT_TYPE = gql`
  query AffiliatePayoutType {
    affiliate_payout_status_type(where: {type: {_neq: Not_Applicable}}) {
      type
    }
  }
`;

export const AFFILIATE_TYPE_BOTH = gql`
query AffiliateType {
  affiliate_type(where: {type: {_in: ["Both"]}}) {
    type
  }
}
`;

export const GET_REFERRED_AFFILIATE_ADD = gql`
query GetReferredAffiliateAdd{
  affiliates(where: {a_type: {_in: [Indirect, Both]}, a_deleted_at: {_is_null: true}, user: {u_is_active: {_eq: true}}}) {
    a_email_id
    a_first_name
    a_last_name
    a_id
    a_type
    user {
      u_id
      u_first_name
      u_last_name
      u_full_name
      u_referral_code
    }
  }
}
`;

export const GET_REFERRED_AFFILIATE_EDIT = gql`
query GetReferredAffiliateEdit($aId: uuid!) {
  affiliates(where: {a_type: {_in: [Indirect, Both]}, a_id: {_neq: $aId}}) {
    a_email_id
    a_first_name
    a_last_name
    a_id
    a_type
    user {
      u_id
      u_first_name
      u_last_name
      u_full_name
    }
  }
}
`;

export const GET_AFFILIATE_TRANSACTIONS = gql `
  query AffiliateTransactions($userId: uuid!, $limit: Int, $offset: Int) {
    user_transactions(where: {u_id: {_eq: $userId}}, limit: $limit, offset: $offset, order_by: {ut_created_at: desc}) {
      ut_created_at
      ut_deleted_at
      ut_fund_transfer_date
      ut_id
      ut_invoice_number
      ut_transaction_amount
      ut_transaction_status
      ut_type
      ut_transaction_id
      ut_transaction_date
      ut_payout_status
    }
    user_transactions_aggregate(where: {u_id: {_eq: $userId}}, limit: $limit, offset: $offset) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_REFERRED_AFFILIATES = gql `query GetReferredAffiliates {
  affiliates(where: {a_type: {_in: [Direct, Both]}, a_deleted_at: {_is_null: true}, user: {u_is_active: {_eq: true}}}) {
    a_id
    a_organization
    user {
      u_referral_code
      u_id
      u_first_name
      u_last_name
      u_full_name
      u_email_id
    }
  }
}`;
